<script setup>
    // Child component of ContactPersonInfo.vue. Handles saving.

    import { ref, watchEffect } from 'vue';
    import { getFromAPI, saveFormViaAPI, getFullUrl } from '../../functionCollection';

    const props = defineProps(['fetchUrl', 'updateUrl', 'userNumber']);
    const emit = defineEmits(['switch-to-show', 'successful-save', 'save-error']);
    const contactPersonInfo = ref(null);
    const showError = ref(false);
    const result = ref();

    watchEffect(async () => {
        const url = getFullUrl(props.fetchUrl, props.userNumber);
        contactPersonInfo.value = await getFromAPI(url);
        // if no previous contactPerson exists, create the needed object
        if (contactPersonInfo.value === "") {
            contactPersonInfo.value = {
                contact_person_anrede: "",
                contact_person_surname: "",
                contact_person_firstname: "",
                email:  "",
                phone: "",
            }
        }
    });

    // saves the contact info from the form.
    async function saveForm() {
        const formData = JSON.parse(JSON.stringify(contactPersonInfo.value));
        result.value = await saveFormViaAPI(getFullUrl(props.updateUrl, props.userNumber), formData);
        if (result.value.success === true) {
            emit('successful-save');
            emit('switch-to-show');
        } else if (result.value.success === false) {
            emit('save-error');
        }
    }

</script>

<template>
    <div class="well" v-if="contactPersonInfo">
        <p v-if="showError">Fehler beim Abspeichern der Daten. Bitte passieren Sie ihre Daten an oder versuchen Sie es später erneut.</p>
        <form>
            <div class="form-group row">
                <label for="firma" class="col-sm-3 col-form-label">Anrede</label>
                <!-- Leider noch binär, muss so schnell es geht geändert werden! -->
                <div class="col-sm-9">
                    <select id="firma" name="firma" class="form-select form-control" v-model="contactPersonInfo.contact_person_anrede">
                        <option value="Frau">Frau</option>
                        <option value="Herr">Herr</option>
                        <option value="Divers">Divers</option>
                    </select>
                </div>
                <label class="col-sm-3 col-form-label">Nachname</label>
                <div class="col-sm-9">
                    <input class="form-control"
                        v-model="contactPersonInfo.contact_person_surname"
                        type="text"
                    />
                </div>
                <label class="col-sm-3 col-form-label">Vorname</label>
                <div class="col-sm-9">
                    <input class="form-control"
                        v-model="contactPersonInfo.contact_person_firstname"
                        type="text"
                    />
                </div>
                <label class="col-sm-3 col-form-label">Email</label>
                <div class="col-sm-9">
                    <input class="form-control"
                        v-model="contactPersonInfo.email"
                        type="text"
                    />
                </div>
                <label class="col-sm-3 col-form-label">Telefon</label>
                <div class="col-sm-9">
                    <input class="form-control"
                        v-model="contactPersonInfo.phone"
                        type="text"
                    />
                </div>
            </div>
        </form>

        <div class="table-footer">
            <button class="btn btn-link footer-button"
                type="submit" @click="saveForm()">
                Speichern
                <i class="far fa-lg fa-save"></i>
            </button>
            <button class="btn btn-link footer-button"
                type="button"
                @click="$emit('switch-to-show')">
                Abbrechen
                <i class="fa-solid fa-lg fa-times"></i>
            </button>
        </div>
    </div>

</template>
